<template>
  <v-card class="app-card pa-4" text height="100%">
    <v-card-title class="justify-center pt-0">
      <h2>Site Seal</h2>
    </v-card-title>
    <v-card-text class="text-center">
      <img class="image--centered" src="/static/img/amui/siteseal.png" width="100" heigth="55" alt="Site Seal" />
      <p class="text-center pt-4 mb-0">
        Install your GlobalSign SSL Certificate Secure Site Seal by clicking on the button below.
      </p>
    </v-card-text>
    <v-card-actions class="pt-4 pb-0">
      <v-row>
        <v-col class="text-center">
          <gg-btn class="justify-center" @click="dialog = true">Install Site Seal</gg-btn>
        </v-col>
      </v-row>
    </v-card-actions>
    <install-site-seal :modal="dialog" @close="dialog = false" />
  </v-card>
</template>

<script>
import InstallSiteSeal from './InstallSiteSeal'

export default {
  name: 'SiteSeal',
  components: {
    InstallSiteSeal,
  },
  data () {
    return {
      dialog: false,
    }
  }
}
</script>

<style scoped>
  .image--centered {
    margin: 0 auto;
  }
</style>
